import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import * as aws from 'aws-sdk';
import {Observable, Observer} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import {v4 as uuid} from 'uuid';
import { ArtfactKind } from '@mrp-brasil/nick-data-commons';

@HookClass('aws.cloudfront')
export class AwsCloudfrontHook extends BaseHook {

    @Hook('06ebe207-a8a1-435f-bfdd-361e2797f804')
    public invalidate(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings) => {

                const cloudfront = new aws.CloudFront({
                    region: 'us-east-1',
                    apiVersion: '2020-05-31',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                const params = {
                    DistributionId: 'EXGJJGTJGHJD8',
                    InvalidationBatch: {
                        CallerReference: uuid(),
                        Paths: {
                            Quantity: 1,
                            Items: [
                                `/*/${inputArtifact.object.systemId}/*`
                            ]
                        }
                    }
                };

                return new Observable((observer: Observer<any>) => {

                    cloudfront.createInvalidation(params, (err: any, data: any) => {
                        if (err) {
                            const output: any = new NickProcessArtfact();
                            output.kind = ArtfactKind.ERROR;
                            output.object = err;
                            observer.error(output);
                        } else {
                            const output: any = new NickProcessArtfact();
                            output.kind = ArtfactKind.ANY;
                            output.object = data;
                            observer.next(output);
                        }
                        observer.complete();
                    });
                });
            }));
    }
}
